import React, { useCallback } from 'react';
import { Typography } from '@material-ui/core';

import Loading from '../../../../components/Loading';

import { ScheduleRow } from '../ScheduleRow';
import { useGetSchedules } from '../../../../hooks/data/schedules';

const ScheduleTable: React.FC = () => {
  const { data, status } = useGetSchedules({ available: true });

  const getMainContent = useCallback(() => {
    if (status === 'loading') {
      return <Loading />;
    }

    if (status !== 'success') {
      return <p>Erro ao buscar os horários. Tente novamente</p>;
    }

    if (data?.length === 0) {
      return <Typography>Você não possui horários cadastrados.</Typography>;
    }

    return data?.map(row => <ScheduleRow key={row.id} schedule={row} />);
  }, [data, status]);

  return (
    <>
      <Typography variant="h5">Horário padrão</Typography>
      {getMainContent()}
    </>
  );
};

export { ScheduleTable };
